var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasPermission
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-new":
                _vm.$route.name === _vm.routeTypes.SubscriptionView.name,
              "show-print": false,
              "show-delete": false,
              "show-save": true,
              "show-cancel": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [_c("vehicle-lookup-side-menu", { ref: "sideMenu" })],
              1
            ),
            _c(
              "div",
              { staticClass: "column" },
              [_c("router-view", { ref: "childView" })],
              1
            ),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "container" }, [_vm._m(0)])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("article", { staticClass: "message is-danger" }, [
      _c("div", { staticClass: "message-header" }, [
        _c("p", [
          _c("span", { staticClass: "icon" }, [
            _c("i", { staticClass: "mdi mdi-shield-alert-outline mdi-24px" }),
          ]),
          _c("span", { staticClass: "is-size-4" }, [_vm._v(" Access Denied")]),
        ]),
      ]),
      _c("div", { staticClass: "message-body" }, [
        _vm._v(" You do not have permission to access this page "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }